const PATTERNS = {
  delhivery: "https://www.delhivery.com/track/package/{t}",
  bluedart: "https://www.bluedart.com/web/guest/trackdartresultthirdparty?trackFor=0&trackNo={t}",
  "blue dart": "https://www.bluedart.com/web/guest/trackdartresultthirdparty?trackFor=0&trackNo={t}",
  dtdc: "https://www.dtdc.in/tracking/tracking_results.asp?strCnno={t}",
  ekart: "https://ekartlogistics.com/shipmenttrack/{t}",
  xpressbees: "https://www.xpressbees.com/shipment/tracking?awbNo={t}",
  shadowfax: "https://track.shadowfax.in/#/track/{t}",
  "ecom express": "https://ecomexpress.in/tracking/?awb_field={t}",
  ecomexpress: "https://ecomexpress.in/tracking/?awb_field={t}",
  fedex: "https://www.fedex.com/fedextrack/?trknbr={t}",
  dhl: "https://www.dhl.com/in-en/home/tracking.html?tracking-id={t}",
  "india post": "https://www.indiapost.gov.in/_layouts/15/dop.portal.tracking/trackconsignment.aspx",
  shiprocket: "https://shiprocket.co/tracking/{t}",
  amazon: "https://track.amazon.in/tracking/{t}",
  gati: "https://www.gati.com/track-shipment/?docket={t}",
};

export function applyTrackingTemplate(template, tracking, orderId) {
  if (!template || !String(template).trim()) return "";
  const awb = encodeURIComponent((tracking || "").trim());
  const oid = encodeURIComponent((orderId || "").trim());
  let url = String(template).trim();
  ["{awb}", "{AWB}", "{tracking}", "{tracking_number}", "{t}"].forEach((p) => { url = url.split(p).join(awb); });
  ["{order_id}", "{order}", "{orderid}"].forEach((p) => { url = url.split(p).join(oid); });
  return url;
}

export function generateTrackingLink(courier, tracking) {
  const key = (courier || "").trim().toLowerCase().replace(/\s+/g, " ");
  const t = (tracking || "").trim();
  if (!key || !t) return "";
  if (PATTERNS[key]) return PATTERNS[key].replace("{t}", t);
  for (const [name, pat] of Object.entries(PATTERNS)) {
    if (key.includes(name) || name.includes(key)) return pat.replace("{t}", t);
  }
  return `https://www.google.com/search?q=${encodeURIComponent(courier)}+tracking+${encodeURIComponent(t)}`;
}
